import PurchaseButton from './PurchaseButton';

export default PurchaseButton;
